import { render, staticRenderFns } from "./CarChat.vue?vue&type=template&id=d52fd246&scoped=true&"
import script from "./CarChat.vue?vue&type=script&lang=js&"
export * from "./CarChat.vue?vue&type=script&lang=js&"
import style0 from "./CarChat.vue?vue&type=style&index=0&id=d52fd246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52fd246",
  null
  
)

export default component.exports